export function networkSpeed () {
   if(navigator.userAgent.includes("Chrome")) {
   measureBW((speed) => {
    
        return speed
      }, 10)
   } else {
    return navigator.connection.downlink * 1024 / 8
   }
}
// 判断当前网络的状态
export function networkState () {
  let speedWork = networkSpeed()
  if (speedWork<100) {
    return '差'
  }else if (speedWork < 2000) {
    return '良'
  }else {
    return '优'
  }
} 
export function measureBW(fn,time) {
    time = time || 1;
    var startTime, endTime, fileSize;
    var count = time ;
    var _this = this;
    function measureBWSimple () {
        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4 && xhr.status === 200) {
                if(!fileSize){
                    fileSize = xhr.responseText.length;
                }
                count --;
                if(count<=0){
                    endTime = Date.now();
                    var speed = fileSize * time  / ((endTime - startTime)/1000) / 1024;
                    fn && fn(Math.floor(speed));
                }
            }
        }
        xhr.open("GET", "https://upload.wikimedia.org/wikipedia/commons/5/51/Google.png?" + Math.random(), true);
        xhr.send();
    }
    startTime = Date.now();
    for(var x = time;x>0;x--){
        measureBWSimple()
    }
}



// WEBPACK FOOTER //
// ./src/router/speed.js